import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface softTypeList {
  /** 分组id */
  group_id: number
  /** 分组名(软件类型|部门) */
  group_name: string
  /** 该类型软件使用数量 */
  Count: number
}

export interface softTypeResponseData {
  /** 软件类型统计列表(Top10) */
  list: softTypeList[]
  /** 已安装软件数量 */
  total?: number
  /** 今日软件变更终端 */
  update_count?: number
}
export interface softGroupTypeList {
  /** 分组id */
  group_id: number
  /** 分组名(软件类型|部门) */
  group_name: string
  /** 该类型软件使用数量 */
  Count: number
}

export interface softGroupTypeResponseData {
  /** 软件类型统计列表(Top10) */
  list: softGroupTypeList[]
}
export interface softUserStatRequestParams {
  /** 是否只查正版软件 0-否 1-是 */
  authenticsoft_flag?: number
}

export interface softUserStatResponseData {
  /** 今日活跃软件（今天有使用过的软件数量） */
  active_count?: number
  /** 已安装软件数(团队安装的软件数量) */
  install_count?: number
  /** 最高频率使用软件 */
  max_times_soft?: string
  /** 闲置软件（近7天未使用过的软件数量） */
  total_count?: number
}
@Injectable()
export class SoftManageService {
  constructor(private http: Http) { }

  getSoftmgrSoftTypeStat() {
    return this.http.post<softTypeResponseData>('/softmgr/soft-type-stat', {})
  }
  getSoftmgrSoftGroupTypeStat () {
    return this.http.post<softGroupTypeResponseData>('/softmgr/soft-group-type-stat', {})
  }
  getSoftmgrSoftUseStat (data: softUserStatRequestParams) {
    return this.http.post<softUserStatResponseData>('/softmgr/soft-use-stat', data)
  }
}
